import { MEChangeGroup } from "./MEChangeGroup";
import { IMEChangeGroup, IMERecordsGroup, IntersectResult, MEChanges, MEInstance } from "./types";

/**
 * Skupina změn zadaná seznamem instancí
 * @internal
 */
export class MERecordsGroup extends MEChangeGroup implements IMERecordsGroup {
    private _instances: string[];
    public get instances(): readonly string[] {
        return this._instances;
    }

    constructor(objIds: string[]) {
        super();
        this._instances = objIds;
    }

    /** Odstraní instanci ze skupiny */
    public override exclude(instanceId: string): void {
        super.exclude(instanceId);
        this._instances = this._instances.filter(i => i !== instanceId);
    }

    /**
     * Vrací seznam změn vzhledem k předchozímu stavu
     * @param existingInstances Seznam instancí, pro které se změny aplikovali instančně
     * @param instances Seznam existujících skupin změn, které se protínají s touto skupinou.
     */
    public merge(instances: string[], intersectsGroups: readonly IntersectResult[]): MEChanges {
        const changedInstances: MEInstance[] = [];
        let newGroups: IMEChangeGroup[] | undefined;
        const remGroups: IMEChangeGroup[] | undefined = [];
        //Pokud se jedná o skupina s pouze jednou instancí - aka vybraný jeden objekt.
        if (this.instances.length === 1) {
            //Projdou se všechny skupiny, do kterých instance spadá, vyjme se a její změny se aplikují instančně.
            for (const ig of intersectsGroups || []) {
                ig.group.exclude(ig.id);
                changedInstances.push({ id: ig.id, values: ig.group.changes });
                //optimalizace pokud skupina vybraná instancemi už excludovala všechny instance, nemá smysl ji držet dát.
                if (ig.group instanceof IMERecordsGroup && ig.group.instances.length == 0) {
                    remGroups.push(ig.group);
                }
            }
        }

        const uniqueInstances: string[] = []; //seznam nových instancí, tj ty které zatím nemají nějakou změnu v poli instancí
        const existingInstances: string[] = [];
        this.instances.forEach(i => instances.includes(i) ? existingInstances.push(i) : uniqueInstances.push(i));
        if (uniqueInstances.length == 0) { //všechny změny se budou dělat nad existujícími instancemi
            this._instances = [];
        } else if (uniqueInstances.length == 1) { //udělat změnu přímo do instancí
            this._instances = [uniqueInstances[0]];
            changedInstances.push({ id: uniqueInstances[0], values: this._changes });
        } else { //v groupě jsou alespoň 2 instance
            this._instances = uniqueInstances;
            newGroups = [this];
        }

        existingInstances.forEach(i => {
            changedInstances.push({ id: i, values: this._changes });
            this.exclude(i);
        });

        return { changedInstances, newGroups, remGroups };
    }
}
